import { render } from "./BonusHome.vue?vue&type=template&id=1c3a236f"
import script from "./BonusHome.vue?vue&type=script&lang=js"
export * from "./BonusHome.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__